import React from 'react'
import Lightbox from 'react-image-lightbox'

class MediaLibrary extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: this.props.media_library || []
		}
	}

	componentWillReceiveProps(props){
		this.setState({
			items: props.media_library || [],
			currentIndex: 0,
			isOpen: false
		})
	}

	handleImageClick(e) {
		this.setState({
			isOpen: true,
			currentIndex: e.target.getAttribute('alt') || 0
		})
	}

	render() {
		return (
			<section className="media_library">
				{ this.state.items && this.state.items.length ? 
					<div>
						<h3>Images</h3>
						<div className="grid">
							{this.state.items.map( (item, i) => { 
								return (
									<div key={i} data-id={item.id} className="media_container">
										<img src={decodeURIComponent(item.imageURL)} alt={item.id} onClick={this.handleImageClick.bind(this)}/>
									</div>
								)
							})}
						</div>
					</div>
					: null
				}
				{
					this.state.isOpen && (
						<Lightbox
							mainSrc={this.state.items[this.state.currentIndex].imageURL}
							nextSrc={this.state.items[(this.state.currentIndex + 1) % this.state.items.length].imageURL}
							prevSrc={this.state.items[(this.state.currentIndex + this.state.items.length - 1) % this.state.items.length].imageURL}
							onCloseRequest={ () => this.setState( {isOpen: false} ) }
							onMovePrevRequest={ () => 
								this.setState({
									currentIndex: (this.state.currentIndex + this.state.items.length - 1) % this.state.items.length
								})
							}
							onMoveNextRequest={ () => 
								this.setState({
									currentIndex: (this.state.currentIndex + 1) % this.state.items.length
								})
							}
						/>
					)
				}
			</section>
		)
	}
}

export default MediaLibrary



// WEBPACK FOOTER //
// ./src/components/media_library.js